import React, { useState } from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export const AddressVerificationDrawer = ({
  isOpen,
  onClose,
  userData,
  onConfirm
}) => {
  const [selectedOption, setSelectedOption] = useState('suggested');
  if (!isOpen) return null;
  const enteredAddress = `${userData.address || '999 Mitchel Ave'}, ${userData.city || 'Lansing'}, ${userData.state || 'MI'} ${userData.zip || '48917'}`;
  const suggestedAddress = '999 West Mitchell Avenue, Lansing, MI 48917';
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end justify-center" data-id="element-65">
      <div className="bg-white rounded-t-xl w-full animate-slide-up max-h-[80vh] overflow-auto" data-id="element-66">
        <div className="p-6" data-id="element-67">
          <div className="flex justify-between items-center mb-4" data-id="element-68">
            <h2 className="text-xl font-bold" data-id="element-69">Use Suggested Address?</h2>
            <button onClick={onClose} className="p-1" data-id="element-70">
              <XIcon size={24} data-id="element-71" />
            </button>
          </div>
          <p className="text-gray-700 mb-6" data-id="element-72">
            We couldn't verify the address you entered, but did find a close
            match. Please select the address you'd like to use.
          </p>
          <div className="space-y-4 mb-6" data-id="element-73">
            <div className={`border rounded-lg p-4 ${selectedOption === 'entered' ? 'border-[#5c5cf5] bg-[#f8f8ff]' : 'border-gray-300'}`} onClick={() => setSelectedOption('entered')} data-id="element-74">
              <div className="flex justify-between items-center mb-2" data-id="element-75">
                <span className="font-medium" data-id="element-76">You Entered:</span>
                <div className={`w-5 h-5 rounded-full border ${selectedOption === 'entered' ? 'border-[#5c5cf5] bg-[#5c5cf5]' : 'border-gray-300'}`} data-id="element-77">
                  {selectedOption === 'entered' && <CheckIcon size={20} className="text-white" data-id="element-78" />}
                </div>
              </div>
              <p className="text-gray-700" data-id="element-79">{enteredAddress}</p>
            </div>
            <div className={`border rounded-lg p-4 ${selectedOption === 'suggested' ? 'border-[#5c5cf5] bg-[#f8f8ff]' : 'border-gray-300'}`} onClick={() => setSelectedOption('suggested')} data-id="element-80">
              <div className="flex justify-between items-center mb-2" data-id="element-81">
                <span className="font-medium" data-id="element-82">Suggested Address:</span>
                <div className={`w-5 h-5 rounded-full border ${selectedOption === 'suggested' ? 'border-[#5c5cf5] bg-[#5c5cf5]' : 'border-gray-300'}`} data-id="element-83">
                  {selectedOption === 'suggested' && <CheckIcon size={20} className="text-white" data-id="element-84" />}
                </div>
              </div>
              <p className="text-gray-700" data-id="element-85">{suggestedAddress}</p>
            </div>
          </div>
          <button className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium" onClick={onConfirm} data-id="element-86">
            Confirm
          </button>
        </div>
      </div>
    </div>;
};